import 'react';
import '../Provider/ThemeContext.js';
import 'classnames';
import 'emotion';
import '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import '../utils/useTheme.js';
import '../utils/useLocalStorage.js';
import { _ as _objectSpread2 } from '../chunk-1b90139e.js';
import '../utils/omit.js';
import '../ColorMode/utils.js';
import '../ColorMode/ColorModeContext.js';
import '../ColorMode/InitializeColorMode.js';
import '../utils/pick.js';
import '../utils/cssProps.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import '../utils/isFunction.js';
import '../utils/get.js';
import '../utils/theme.js';
import '../utils/getCSSFromStyleObject.js';
import '../utils/useStyle.js';
import '../utils/usePrevious.js';
import '../utils/useOptionsState.js';
import '../utils/omitBy.js';
import '../utils/useDefaultProps.js';
import '../utils/useDebounce.js';
import 'lodash/uniq';
import '../utils/useClassName.js';
import '../utils/getMediaQueryList.js';
import '../utils/useBreakpointValue.js';
import '../utils/useBreakpoint.js';
import 'reakit/Id';
import '../utils/uniqueId.js';
import '../utils/times.js';
import '../utils/parseIcons.js';
import { tint, shade } from '../utils/colors.js';
import { generateColorVariants, generateTextVariants } from '../utils/palette.js';
import '../utils/mergeRefs.js';
import 'deepmerge';
import 'lodash/set';
import '../utils/applyTheme.js';
import '../utils/bindFns.js';
import '../utils/createComponent.js';
import '../utils/createElement.js';
import '../utils/createHook.js';
import '../utils/forwardRefWithUse.js';
import '../utils/fieldAdaptors.js';
import 'capsize';
import '../utils/getCapsizeStyles.js';
import '@emotion/is-prop-valid';
import '../utils/htmlProps.js';
import '../utils/OutsideClickHandler.js';
var defaultPalette = {
  background: 'white',
  black: '#0b0e13',
  text: '#212121',
  primary: '#574feb',
  secondary: '#9e46d8',
  info: '#1e67d5',
  success: '#0a7d33',
  danger: '#da1717',
  warning: '#ed9c22',
  gray: '#626f84'
};
var defaultDarkPalette = {
  background: '#1a212d',
  black: '#0b0e13',
  default: '#27303f',
  defaultInverted: 'white',
  text: 'white',
  text100: '#b1bccd',
  text200: '#c1c9d7',
  text300: '#d0d7e1',
  text400: '#e0e4eb',
  primary: '#574feb',
  secondary: '#9e46d8',
  info: '#1e67d5',
  success: '#0a7d33',
  danger: '#da1717',
  warning: '#ed9c22'
};

var getDefaultPalette = function getDefaultPalette(overrides) {
  var _overrides$text;

  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, generateTextVariants((_overrides$text = overrides === null || overrides === void 0 ? void 0 : overrides.text) !== null && _overrides$text !== void 0 ? _overrides$text : defaultPalette.text)), {}, {
    background: defaultPalette.background,
    black: defaultPalette.black,
    black500: defaultPalette.black,
    black400: tint(0.05, defaultPalette.black)({
      backgroundColor: overrides.background || defaultPalette.background,
      colorMode: 'default'
    }),
    black300: tint(0.1, defaultPalette.black)({
      backgroundColor: overrides.background || defaultPalette.background,
      colorMode: 'default'
    }),
    black200: tint(0.15, defaultPalette.black)({
      backgroundColor: overrides.background || defaultPalette.background,
      colorMode: 'default'
    }),
    black100: tint(0.2, defaultPalette.black)({
      backgroundColor: overrides.background || defaultPalette.background,
      colorMode: 'default'
    }),
    white: 'white',
    white500: 'white',
    white600: '#f7f7fa',
    white700: '#f2f2f5',
    white800: '#e6e6eb',
    white900: '#d9d9e1',
    default: '#fcfcfd',
    defaultInverted: '#212121'
  }, generateColorVariants({
    paletteKey: 'primary',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.primary || defaultPalette.primary
  })), generateColorVariants({
    paletteKey: 'secondary',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.secondary || defaultPalette.secondary
  })), generateColorVariants({
    paletteKey: 'info',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.info || defaultPalette.info
  })), generateColorVariants({
    paletteKey: 'success',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.success || defaultPalette.success
  })), generateColorVariants({
    paletteKey: 'danger',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.danger || defaultPalette.danger
  })), generateColorVariants({
    paletteKey: 'warning',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.warning || defaultPalette.warning,
    paletteOverrides: function paletteOverrides(_ref) {
      var color = _ref.color;
      return {
        warningTintInverted: shade(0.7, color)()
      };
    }
  })), generateColorVariants({
    paletteKey: 'gray',
    backgroundColor: overrides.background || defaultPalette.background,
    color: overrides.gray || defaultPalette.gray,
    paletteOverrides: function paletteOverrides(_ref2) {
      var color = _ref2.color;
      return {
        gray700: shade(0.2, color)(),
        gray800: shade(0.3, color)(),
        gray900: shade(0.4, color)()
      };
    }
  })), {}, {
    modes: {
      dark: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, defaultDarkPalette), generateColorVariants({
        paletteKey: 'primary',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.primary || defaultDarkPalette.primary
      })), generateColorVariants({
        paletteKey: 'secondary',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.secondary || defaultDarkPalette.secondary
      })), generateColorVariants({
        paletteKey: 'info',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.info || defaultDarkPalette.info
      })), generateColorVariants({
        paletteKey: 'success',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.success || defaultDarkPalette.success
      })), generateColorVariants({
        paletteKey: 'danger',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.danger || defaultDarkPalette.danger
      })), generateColorVariants({
        paletteKey: 'warning',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.warning || defaultDarkPalette.warning,
        paletteOverrides: function paletteOverrides(_ref3) {
          var color = _ref3.color;
          return {
            warningTintInverted: shade(0.7, color)()
          };
        }
      })), generateColorVariants({
        paletteKey: 'gray',
        colorMode: 'dark',
        backgroundColor: overrides.background || defaultDarkPalette.background,
        color: overrides.gray || defaultPalette.gray
      })), {}, {
        black: defaultPalette.black,
        black500: defaultPalette.black,
        black400: tint(0.25, defaultPalette.black)({
          backgroundColor: overrides.background || defaultDarkPalette.background,
          colorMode: 'default'
        }),
        black300: tint(0.5, defaultPalette.black)({
          backgroundColor: overrides.background || defaultDarkPalette.background,
          colorMode: 'default'
        }),
        black200: tint(0.75, defaultPalette.black)({
          backgroundColor: overrides.background || defaultDarkPalette.background,
          colorMode: 'default'
        }),
        black100: tint(1, defaultPalette.black)({
          backgroundColor: overrides.background || defaultDarkPalette.background,
          colorMode: 'default'
        })
      })
    }
  }, overrides);
};

export default getDefaultPalette;